export function taskAssigneeIds(task) {
  if (Array.isArray(task.assignees) && task.assignees.length > 0) {
    return task.assignees.map((person) => person.id);
  }
  return task.assignee_id != null ? [task.assignee_id] : [];
}

export function taskWatcherIds(task) {
  if (!Array.isArray(task.watchers)) return [];
  return task.watchers.map((person) => person.id);
}

export function taskMatchesFilters(
  task,
  { assigneeFilter, priorityFilter, overdueOnly, watcherOnly, currentUserId, isOverdue }
) {
  const assigneeIds = taskAssigneeIds(task);
  if (assigneeFilter === "none") {
    if (assigneeIds.length > 0) return false;
  } else if (assigneeFilter && !assigneeIds.some((id) => String(id) === assigneeFilter)) {
    return false;
  }
  if (priorityFilter && task.priority !== priorityFilter) return false;
  if (overdueOnly && !isOverdue(task)) return false;
  if (watcherOnly && currentUserId != null) {
    if (!taskWatcherIds(task).includes(currentUserId)) return false;
  }
  return true;
}

export function buildVisibleTasks(tasks, filters, filtersActive) {
  if (!filtersActive) return tasks;

  const matchingIds = new Set(
    tasks.filter((t) => taskMatchesFilters(t, filters)).map((t) => t.id)
  );

  return tasks.filter((task) => {
    if (matchingIds.has(task.id)) return true;
    if (!task.parent_task_id) {
      return tasks.some(
        (t) => t.parent_task_id === task.id && matchingIds.has(t.id)
      );
    }
    return false;
  });
}

export function rootTasksForColumn(tasks, columnId) {
  return tasks
    .filter((t) => t.column_id === columnId && !t.parent_task_id)
    .sort((a, b) => a.position - b.position);
}

export function countRootTasks(tasks, visibleTasks, filtersActive) {
  const source = filtersActive ? visibleTasks : tasks;
  return source.filter((t) => !t.parent_task_id).length;
}
